function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.897 4.993a2.936 2.936 0 01-4.14 0 2.935 2.935 0 010-4.14 2.935 2.935 0 014.14 0 2.937 2.937 0 010 4.14zm-11.21 2.932a2.936 2.936 0 014.139 0 2.934 2.934 0 010 4.139L13.788 25.102a2.936 2.936 0 01-4.14 0L.855 16.307a2.936 2.936 0 010-4.139 2.934 2.934 0 014.139 0l6.726 6.725L22.687 7.925z",
  fill: "#FD55D8"
});

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none"
  }, props), _ref);
};

export default SvgTick;